import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Drawer as MuiDrawer,
  Toolbar,
  styled,
} from "@mui/material";
import {
  SmsOutlined,
  SmsRounded,
  VideoLibraryOutlined,
  VideoLibraryRounded
} from "@mui/icons-material";
import WInvestLogo from "@components/logos";
import AuthButton from "../authentication/Button";
import { GameIcon, LearnIcon, TrackerIcon } from "../icons";
import { useNavigation } from "@hooks";
import ComingSoonWrapper from "@ui-library/ComingSoon";

const COLOUR = "#5F32B6";
const DRAWER_WIDTH = 240;

const Drawer = styled(MuiDrawer)(() => ({
  "& .MuiDrawer-paper": {
    boxSizing: "border-box",
    width: DRAWER_WIDTH,
    display: "flex",
    flexDirection: "column",
  },
}));

const Frame = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

const Header = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: "8px",
}));

const DrawerItem = ({ icon, text, selected, handleNavigate, ...props }) => (
  <ListItem disablePadding sx={{color: COLOUR}}>
    <ListItemButton
      onClick={handleNavigate}
      selected={selected}
      {...props}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
  </ListItem>
);

const Footer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: "16px",
}));

const LeftNavBar = (props) => {
  const { mobileOpen, handleDrawerClose, handleDrawerTransitionEnd, handleNavigate } = props;
  const { isMobileNav, isSelected } = useNavigation();

  const drawer = (
    <>
      <Frame>
        {isMobileNav ? <Toolbar /> :
          <Header>
            <WInvestLogo
              onClick={() => handleNavigate("projection")}
              style={{ cursor: "pointer" }}
            />
          </Header>
        }
        <List>
          <DrawerItem
            icon={<TrackerIcon color={COLOUR} selected={isSelected.projection} />}
            text={"Projection"}
            selected={isSelected.projection}
            handleNavigate={() => handleNavigate("projection")}
          />
          <DrawerItem
            icon={<LearnIcon color={COLOUR} selected={isSelected.learn} />}
            text={"Learn"}
            selected={isSelected.learn}
            handleNavigate={() => handleNavigate("learn")}
          />
          <ComingSoonWrapper>
            <DrawerItem
              icon={
                isSelected.course
                  ? <VideoLibraryRounded sx={{ color: COLOUR }} />
                  : <VideoLibraryOutlined sx={{ color: COLOUR }} />
              }
              text={"Our Course"}
              selected={isSelected.course}
              handleNavigate={() => handleNavigate("course")}
            />
          </ComingSoonWrapper>
          <DrawerItem
            icon={<GameIcon color={COLOUR} selected={isSelected.game} />}
            text={"Play"}
            selected={isSelected.game}
            handleNavigate={() => handleNavigate("game")}
          />
          {/* TEMPORARY -- exclude "Chat" until account behaviour is implemented */}
          {/* <DrawerItem
            icon={
              isSelected.ai
                ? <SmsRounded sx={{ color: COLOUR }} />
                : <SmsOutlined sx={{ color: COLOUR }} />
            }
            text={"Chat"}
            selected={isSelected.ai}
            handleNavigate={() => handleNavigate("ai")}
          /> */}
        </List>
      </Frame>
      <Footer>
        <AuthButton />
      </Footer>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { sm: DRAWER_WIDTH }, flexShrink: { sm: 0 } }}
      aria-label="mailbox folders"
    >
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onTransitionEnd={handleDrawerTransitionEnd}
        onClose={handleDrawerClose}
        sx={{ display: { xs: "block", sm: "none" } }}
        // MUI v6+
        // slotProps={{
        //   root: {
        //     keepMounted: true, // Better open performance on mobile.
        //   },
        // }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{ display: { xs: "none", sm: "block" } }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export default LeftNavBar;
